import { restApiDomain } from "@js/nwcc-domains.js";

export async function getLuts(queryArgs, flagLut) {
    const endpoint = "reference-data";
    const visibility = queryArgs["visibility"] || "public";
    const args = visibility === "all" ? `?visibility=${visibility}` : "";
    const url = `${restApiDomain}/${endpoint}${args}`;
    const response = await fetch(url);
    if (response.ok) {
        const results = await response.json();
        results.flags = flagLut;
        return results;
    }
}
